import React from "react";
import { orderOriginBadge } from "../../../../utils/orderDisplay";

export interface SourcePercentage {
  source: string;
  percentage: number;
}

export default ({ sources }: { sources: SourcePercentage[] }) => {
  const visible = (sources || []).filter(x => x.percentage > 0);
  const sum = visible.reduce((acc, x) => acc + x.percentage, 0);
  if (sum === 0) return null;

  const parts = visible.map(x => {
    const origin = orderOriginBadge(x.source);
    return {
      key: x.source,
      tone: origin.tone,
      label: `${origin.label} ${Math.round(x.percentage)}%`,
      width: `${(x.percentage * 100) / sum}%`,
    };
  });

  return (
    <span className="o360-sources">
      <span className="ax-progress-stacked o360-sources-bar" role="img" aria-label={`Fuentes: ${parts.map(x => x.label).join(", ")}`}>
        {parts.map(x => (
          <span key={x.key} className="ax-progress" style={{ width: x.width }}>
            <span className={`ax-progress-bar o360-source-${x.tone}`} />
          </span>
        ))}
      </span>
      <span className="o360-sources-legend" aria-hidden="true">
        {parts.map(x => (
          <span key={x.key} className="o360-sources-item">
            <span className={`o360-sources-dot o360-source-${x.tone}`} />
            {x.label}
          </span>
        ))}
      </span>
    </span>
  );
};
